import React, { ReactNode } from 'react';
import { Box, Td, Text, Tr } from '@chakra-ui/react';

interface Props {
  label: any;
  children?: ReactNode;
  verticalAlign?: string;
  noBorder?: boolean;
  className?: string;
  px?: string;
  renderFunction?: any;
  type?: any;
  mb?: number | string;
  minHeight?: string;
  color?: string;
}
export default function TableElement({
  className,
  label,
  children,
  verticalAlign = 'top',
  noBorder = false,
  px,
  renderFunction,
  type = "",
  mb=5,
  minHeight = '20px',
  color = 'black',

}: Props) {
  if (type && type === 'review') {
    return (
      <Box className={`flex flex-col`} sx={{ marginBottom: mb, paddingRight: 10, minHeight: minHeight, color: color }}>


        <Text as="label" sx={{ fontWeight: 'bold' }}>
          {label}
          {renderFunction ? renderFunction() : ""}
        </Text>
        <Box className={className || ""} sx={{ marginTop: 2 }} whiteSpace={'normal'}>{children}</Box>
      </Box>
    )
  }
  return (
    <Tr verticalAlign={verticalAlign} sx={{ borderBottom: noBorder ? "none" : "" }}>
      <Td textAlign={'left'} fontWeight={'bold'} sx={{ borderBottom: noBorder ? "none" : "" }} px={px ? px : ""}>
        {label}
        {renderFunction ? renderFunction() : ""}
      </Td>
      {children && <Td className={className || ""} whiteSpace={'normal'} sx={{ borderBottom: noBorder ? "none" : "" }}>{children}</Td>}
    </Tr>
  );
}
